import React from 'react';

const QRCodeGenerator = () => {
  return (
    <div className='page-container'>
      <div className='page-card'>
      <h2 className="page-title">QR Code Generation</h2>
      </div>
    </div>
  );
};

export default QRCodeGenerator;